import { Component, EventEmitter, Output } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import { LoaderService } from 'src/app/services/loader.service'
import { updatePassword, getCurrentUser } from 'aws-amplify/auth'
import { MustMatch, MustNotMatch } from 'src/app/common/validators/must-match'
import { PASSWORD_REGEXP } from 'src/app/common/validators/sharedRegex'
import { PasswordValidationStatusComponent } from '../pasword-validation-status/pasword-validation-status.component'
import { CustomBxInputComponent } from 'src/app/components/custom-bx-input/custom-bx-input.component'
import { provideNgxMask } from 'ngx-mask'
import { AuthService } from 'src/app/common/services/auth.service'

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    providers: [provideNgxMask()],
    imports: [PasswordValidationStatusComponent, CustomBxInputComponent, ToastrModule]
})
export class ChangePasswordComponent {
  @Output() onBack = new EventEmitter<void>()
  @Output() onPasswordUpdated = new EventEmitter<boolean>()
  form: UntypedFormGroup
  passwordUpdated: boolean = false
  readonly customMessage = {
    pattern: () => 'Incorrect username or password'
  }
  constructor (
    private fb: UntypedFormBuilder,
    private toast: ToastrService,
    private loaderService: LoaderService,
    private authService: AuthService
  ) {
    this.form = this.prepareForm()
  }

  get oldPasswordControl () { return this.form.get('oldPassword') }
  get newPasswordControl () { return this.form.get('newPassword') }
  get confirmPasswordControl () { return this.form.get('confirmPassword') }

  private prepareForm (): UntypedFormGroup {
    return this.fb.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(PASSWORD_REGEXP)
      ]],
      confirmPassword: ''
    }, {
      validators: [
        MustMatch('newPassword', 'confirmPassword'),
        MustNotMatch('oldPassword', 'newPassword')
      ]
    })
  }

  clearForm () {
    this.form.reset('')
    this.form.markAsPristine()
    this.form.markAsUntouched()
  }

  goBack () {
    this.clearForm()
    this.onBack.emit()
  }

  done () {
    this.passwordUpdated = false
    this.clearForm()
    this.onBack.emit()
    this.authService.signOut()
  }

  async changePassword () {
    this.loaderService.show()
    const oldPass = this.form.get('oldPassword')?.value?.trim()
    const newPass = this.form.get('newPassword')?.value?.trim()
    if (!oldPass || !newPass) {
      this.toast.error($localize`Please fill in both fields.`)
      this.loaderService.hide()
      return
    }
    try {
      const user = await getCurrentUser()
      await updatePassword({ oldPassword: oldPass, newPassword: newPass })
      this.clearStorage()
      this.passwordUpdated = true
      this.onPasswordUpdated.emit(true)
      setTimeout(() => {
        this.authService?.signOut()
      }, 1000)
    } catch (err: any) {
      this.toast.error(err?.message || $localize`Something went wrong`)
    } finally {
      this.loaderService.hide()
    }
  }
  clearStorage () {
    sessionStorage.clear()
    localStorage.clear()
    const isLocalhost = window.location.hostname === 'localhost'
     const secure = isLocalhost ? '' : 'Secure;'
    const cookies = document.cookie.split(';')
    cookies.forEach(cookie => {
      const name = cookie.split('=')[0]?.trim()
      document.cookie = `${name}=; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Path=/; ${secure}`
    })
  }
}
